/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'reactstrap';
import {
  XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Bar, ComposedChart, Line,
  Label,
} from 'recharts';
import { colorsCombination, setCurrencyFormat } from '../../../../utils/helpers';

const NewReturnChart = ({
  dir, dataToPlot, height,
  index
}) => {

  const [color1, color2, color3] = colorsCombination[(index) % 10];
  return (
    <Col xs={12}>
      <div dir="ltr">
        <ResponsiveContainer height={height}>
          <ComposedChart
            data={dataToPlot}
            margin={{ top: 0, right: 0, left: 25, bottom: 0 }}
          >
            <CartesianGrid vertical={false} horizontal  stroke="#FF0000" strokeWidth={2} />
            <XAxis dataKey="purchaseDate" reversed={dir === 'rtl'} />

            <YAxis yAxisId="left" orientation={dir === 'rtl' ? 'right' : 'left'}
              tickFormatter={item => setCurrencyFormat(item, false)}
              width={90} type="number"
              allowDataOverflow >
              <Label angle={-90} value="Value"
                position='insideLeft' style={{ textAnchor: 'middle' }} />
            </YAxis>
            <YAxis yAxisId="right" orientation={dir === 'rtl' ? 'left' : 'right'}
              tickFormatter={item => `${item}%`}
              width={90} type="number"
              allowDataOverflow >
              <Label angle={-90} value="% New Customer"
                position='insideRight' style={{ textAnchor: 'middle' }} />
            </YAxis>
            <Tooltip />  <Legend />
            <Line dot={false} yAxisId="right" dataKey={"% New Customer"?.toString()} fill={color3} />
            <Bar type="monotone" stackId="count" yAxisId="left" dataKey={"New Customers Count"?.toString()} fill={color1} />
            <Bar type="monotone" stackId="count" yAxisId="left" dataKey={"Repeated Customers Count"?.toString()} fill={color2} />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </Col>
  );
};

NewReturnChart.propTypes = {
  dir: PropTypes.string.isRequired,
  dataToPlot: PropTypes.arrayOf({}).isRequired,
  height: PropTypes.number.isRequired,
  index: PropTypes.number,
};

NewReturnChart.defaultProps = {
  index: 0
}

export default NewReturnChart;
